import { useState, useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Menu from './components/Menu';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FavoritesPanel from '../../components/feature/FavoritesPanel';
import { useFavorites } from '../../hooks/useFavorites';

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');
  const [isFavoritesPanelOpen, setIsFavoritesPanelOpen] = useState(false);
  const { favorites, removeFavorite, clearFavorites, updateQuantity } = useFavorites();
  const menuRef = useRef<any>(null);

  const handleMascotClick = (category: 'pizzas' | 'burgers' | 'italienne') => {
    const menuElement = document.getElementById('menu');
    if (menuElement) {
      menuElement.scrollIntoView({ behavior: 'smooth' });
    }
    setTimeout(() => {
      if (menuRef.current && menuRef.current.handleMainCategoryClick) {
        if (category === 'italienne') {
          menuRef.current.scrollToItalienne?.();
        } else {
          menuRef.current.handleMainCategoryClick(category);
        }
      }
    }, 600);
  };

  return (
    <div className="min-h-screen bg-cream">
      <Navbar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        favoritesCount={favorites.length}
        onOpenFavorites={() => setIsFavoritesPanelOpen(true)}
      />
      <Hero onMascotClick={handleMascotClick} />

      <Menu ref={menuRef} />
      <Contact />

      <Footer />

      <FavoritesPanel
        isOpen={isFavoritesPanelOpen}
        onClose={() => setIsFavoritesPanelOpen(false)}
        favorites={favorites}
        onRemove={removeFavorite}
        onClear={clearFavorites}
        onUpdateQuantity={updateQuantity}
      />
    </div>
  );
}
